import { LoaderCircleIcon } from 'lucide-react'
import { MotionConfig } from 'motion/react'
import { useMemo } from 'react'
import { Outlet } from 'react-router'

import { SupportButton } from 'apps/components/support/SupportButton'
import { useEmployerRenewalConfig } from 'apps/employer_renewals/providers/EmployerRenewalConfigProvider'
import { Banner } from 'slab'

import ProfileMenuToolbar from '../toolbar/ProfileMenuToolbar'

export default function RenewalLayout () {
  const { isLoading, isError } = useEmployerRenewalConfig()

  const content = useMemo(() => {
    if (isLoading) {
      return (
        <div className='flex grow items-center justify-center'>
          <LoaderCircleIcon size={24} className='animate-spin text-gray-500' />
        </div>
      )
    }

    if (isError) {
      return (
        <div className='flex grow items-center justify-center'>
          <Banner type='critical' title='Error loading renewal information'>
            Something went wrong. Please try reloading the page. If the problem persists, please contact support.
          </Banner>
        </div>
      )
    }
    return (
      <Outlet />
    )
  }, [isLoading, isError])

  return (
    <div className='min-h-svh flex flex-col items-stretch bg-gray-50 isolate'>
      <ProfileMenuToolbar />
      <div className='flex flex-col flex-1'>
        <MotionConfig transition={{ duration: 0.3 }}>
          {content}
        </MotionConfig>
      </div>
      <div className='py-8 self-center'>
        <SupportButton />
      </div>
    </div>
  )
}
